import {
    Dialog,
    GenericSuspense,
    Menu,
    useSetCurrentDocumentTitle,
    useTranslationRoute,
    useTranslations,
    useUrlParamsValueToString,
} from "@harea/component";
import { useCallback, useEffect } from "react";
import { TTimeOff } from "@harea/component";
import _ from "lodash";
import { Outlet, useNavigate, useParams, useLocation } from "react-router-dom";
import { useTimeOffQuery } from "hooks/useTimeOffQuery";
import { AppointmentDetailsLoader } from "../components/AppointmentDetailsLoader";

const ProjectCalendarDetailsAppointmentContainer = () => {

    const [
        DETAILS
    ] = useTranslations(i18n)
    const { id } = useParams()
    const location = useLocation()
    const { data } = useTimeOffQuery(parseInt(id));
    useSetCurrentDocumentTitle('TimeOffTitle', data?.title)
    const navigate = useNavigate()
    const urlParamsToString = useUrlParamsValueToString()

    const isEditMode = location.pathname.includes('/edit')

    const handleClose = useCallback(() => {
        navigate(`..?${urlParamsToString}`)
    }, [id, urlParamsToString])

    return (
        <>
            {!isEditMode && (
                <Dialog
                    open={id !== undefined}
                    className="max-w-3xl"
                    title={data?.title ?? DETAILS}
                    onClose={handleClose}>
                    <AppointmentDetailsLoader onDeleted={handleClose} />
                </Dialog>
            )}
            <Outlet />
        </>
    );
};

const i18n = [
    'std_details'
]

export default ProjectCalendarDetailsAppointmentContainer;

export type VacationDialogStateProps = {
    id?: number;
    isKanban?: boolean;
    onClose?: () => void;
    onSubmited?: (data?: TTimeOff) => void;
    onDeleted?: (data?: Record<string, any>) => void;
};
